// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/opt/build/repo/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-app-js": () => import("/opt/build/repo/src/pages/app.js" /* webpackChunkName: "component---src-pages-app-js" */),
  "component---src-pages-elements-jsx": () => import("/opt/build/repo/src/pages/elements.jsx" /* webpackChunkName: "component---src-pages-elements-jsx" */),
  "component---src-pages-index-js": () => import("/opt/build/repo/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-login-js": () => import("/opt/build/repo/src/pages/login.js" /* webpackChunkName: "component---src-pages-login-js" */)
}

